import React from 'react';
import cn from 'classnames';
import A_ChatAvatar from '@/components/A_Atoms/A_ChatAvatar/A_ChatAvatar';
import { Q_Icon } from '@/components/Q_Quarks/Q_Icon/Q_Icon';
import { ChatUser } from '@/services/chatApi';
import { displayName } from '@/utils/chat';
import styles from './M_ChatUserRow.module.css';

interface M_ChatUserRowProps {
  user: ChatUser;
  /** Подпись справа от имени: роль в группе или подсказка действия. */
  caption?: string;
  isSelected?: boolean;
  onClick?: (user: ChatUser) => void;
  action?: React.ReactNode;
}

export default function M_ChatUserRow({
  user,
  caption,
  isSelected = false,
  onClick,
  action,
}: M_ChatUserRowProps) {
  const name = displayName(user);
  const isInteractive = Boolean(onClick);

  const content = (
    <>
      <A_ChatAvatar title={name} src={user.avatar} size={40} />
      <span className={styles.body}>
        <span className={cn(styles.name, 'text-p-8')}>{name}</span>
        <span className={cn(styles.handle, 'text-caption')}>
          @{user.username}
        </span>
      </span>
      {caption && (
        <span className={cn(styles.caption, 'text-caption')}>{caption}</span>
      )}
      {isSelected && (
        <Q_Icon.CheckmarkIcon width={20} height={20} fill='none' />
      )}
      {action}
    </>
  );

  if (!isInteractive) {
    return <div className={styles.wrapper}>{content}</div>;
  }

  return (
    <button
      type='button'
      className={cn(styles.wrapper, styles.interactive, {
        [styles.selected]: isSelected,
      })}
      onClick={() => onClick?.(user)}
    >
      {content}
    </button>
  );
}
